var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sitio-layout',{attrs:{"id":"404"}},[_c('div',{staticClass:"app__view"},[_c('h1',[_vm._v("This is an 404 page")])])])}
var staticRenderFns = []

export { render, staticRenderFns }